import * as $ from 'pumpkin.js'
import debounce from '../lib/debounce'

export default function ($el, options) {
  let { initialState } = options

  const $header = $.qs('[data-slot="header"]', $el)
  const $body = $.qs('[data-slot="body"]', $el)

  if (!$header || !$body) {
    console.warn(
      'The accordion component expects two slots, "header" and "body", declared using the "data-slot" attribute. Example: <div data-slot="header"></div>'
    )
    return
  }

  const checkHash = id => {
    if (!window.location.hash) return false
    if (!id) return false
    return window.location.hash.substring(1) === id
  }

  let open = initialState
    ? !!initialState
    : !!checkHash($body.getAttribute('id'))

  let initialHeight = `${$body.offsetHeight}px`

  const ariaAttr = {
    selected: val => $header.setAttribute('aria-selected', val),
    expanded: val => $header.setAttribute('aria-expanded', val),
    hidden: val => $body.setAttribute('aria-hidden', val)
  }

  const handleOpen = () => {
    ariaAttr.selected(true)
    ariaAttr.expanded(true)
    ariaAttr.hidden(false)
    $el.classList.add('-open')

    $.css($body, { height: initialHeight })
  }

  const handleClose = () => {
    ariaAttr.selected(false)
    ariaAttr.expanded(false)
    ariaAttr.hidden(true)
    $el.classList.remove('-open')

    $.css($body, {
      height: 0
    })
  }

  const handleToggle = e => {
    e.preventDefault()
    open ? handleClose() : handleOpen()
    open = !open
  }

  const handleResize = debounce(() => {
    $.css($body, { height: '' })
    initialHeight = `${$body.offsetHeight}px`
    $.css($body, { height: open ? initialHeight : 0 })
  }, 50)

  $el.classList.remove('dehydrated')
  open ? handleOpen() : handleClose()

  $header.addEventListener('click', handleToggle)
  window.addEventListener('resize', handleResize)

  return () => {
    $header.removeEventListener('click', handleToggle)
    window.removeEventListener('resize', handleResize)

    $.css($body, { height: '' })

    $el.classList.add('dehydrated')
  }
}
